export default {
  URL_ENDPOINT: 'https://hermes-api.wtfapps.dev.br/api/v1',
  URL_IMAGE: 'https://hermes-api.wtfapps.dev.br/'
//https://api.hermesagent.com:3000/api/v1
  // USER_TOKEN: config.state.user_data.token
  //https://api.hermesagent.com:3000
}